import BaseComponent from '../BaseComponent';
import PropTypes from 'prop-types';
import {createRef} from 'react';
import React from "react";
import AccordionDetails from '@mui/material/AccordionDetails';

class AccordionItem extends BaseComponent {

  constructor(props) {
    super(props);
    this.contentRef = createRef();
  }

  render() {
    return <AccordionDetails>
      {this.props.children}
    </AccordionDetails>
  }
}

AccordionItem.propTypes = {
  accordionItemHead: PropTypes.node,
  onStateChange: PropTypes.func,
  opened: PropTypes.bool,
}

export default AccordionItem;